import React from "react";
import { useRequiredAuth } from "../common/guard/requiredAuth";
import {
  Redirect,
  Route,
  Switch,
} from "react-router-dom/cjs/react-router-dom.min";
import UserGuide from "../training/pages/UserGuide";
import Dashboard from "./pages/Dashboard";
import MinisterialDashboard from "./pages/MinisterialDashboardNew";
import AllGraduatesDashboard from "./pages/AllGraduatesDashboard";
import MenuBar from "./components/MenuBar";
import SkillsProfile from "./pages/SkillsProfile";
import SkillsQualifications from "./pages/SkillsQualifications";
import TrainingData from "./pages/TrainingData";

const Layout = () => {

  return (
    <React.Fragment>
      <MenuBar />
      <Switch>
        <Route
          path="/skills-dashboard/dashboard"
          component={MinisterialDashboard}
        />

        <Route
          path="/skills-dashboard/allgraduates"
          component={AllGraduatesDashboard}
        />
       
         <Route
          path="/skills-dashboard/profile"
          component={SkillsProfile}
        />
         <Route
          path="/skills-dashboard/qualifications"
          component={SkillsQualifications}
        />
        
        <Route
          path="/skills-dashboard/training-data"
          component={TrainingData}
        />

        <Route path="/skills-dashboard/user-guide" 
          component={UserGuide} />
        
        <Route
          path="/skills-dashboard"
          component={() => <Redirect to={"/skills-dashboard/dashboard"} />}
        />
      </Switch>
    </React.Fragment>
  );
};

export default Layout;
